"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconLightBulbShine = /*#__PURE__*/
function (_Icon) {
  _inherits(IconLightBulbShine, _Icon);
  function IconLightBulbShine(props) {
    var _this;
    _classCallCheck(this, IconLightBulbShine);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconLightBulbShine).call(this, props));
    _this.name = 'IconLightBulbShine';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "light-bulb-shine_svg__group0"
    }, _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path0",
      d: "M10.514 24a.5.5 0 010-1h3a.5.5 0 010 1h-3z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path1",
      d: "M9.514 22a.5.5 0 010-1h5a.5.5 0 010 1h-5z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path2",
      d: "M12.014 4a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path3",
      d: "M5.65 6.636a.497.497 0 01-.353-.146L3.174 4.369a.5.5 0 01.707-.708l2.122 2.121a.5.5 0 01-.353.854z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path4",
      d: "M18.378 6.636a.5.5 0 01-.354-.853l2.121-2.121a.5.5 0 11.708.707L18.731 6.49a.497.497 0 01-.353.146z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path5",
      d: "M.514 13a.5.5 0 010-1h3a.5.5 0 010 1h-3z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path6",
      d: "M20.514 13a.5.5 0 010-1h3a.5.5 0 010 1h-3z"
    }), _react2.default.createElement("path", {
      className: "light-bulb-shine_svg__path7",
      d: "M9.514 20c-.551 0-1-.448-1-1v-.762a.497.497 0 00-.215-.41 6.499 6.499 0 01-2.785-5.341 6.51 6.51 0 016.5-6.493 6.46 6.46 0 014.599 1.911 6.454 6.454 0 011.901 4.596 6.479 6.479 0 01-2.786 5.326.5.5 0 00-.214.41V19a1 1 0 01-1 1h-5zm2.5-13.007A5.466 5.466 0 008.129 8.6a5.503 5.503 0 00.742 8.407c.403.28.643.74.643 1.231V19h5v-.763c0-.491.24-.951.644-1.231a5.48 5.48 0 002.356-4.505 5.507 5.507 0 00-5.494-5.507l-.006-.25v.249z"
    })));
    return _this;
  }
  return IconLightBulbShine;
}(_Icon3.default);
exports.default = IconLightBulbShine;